export default __webpack_public_path__ + "static/product_001-f6ceb2c3338b93b302476d585c161025.jpg";